import { MdOutlineCalendarMonth } from 'react-icons/md'
import { useTranslation } from 'next-i18next'

interface ProductLargeOrdersProps {
  deliveryBy?: string
}

const ProductLargeOrders: React.FC<ProductLargeOrdersProps> = ({
  deliveryBy,
}) => {
  const { t: translate } = useTranslation(['common'])
  if (!deliveryBy) return null

  return (
    deliveryBy && (
      <p className="text-sm mt-2 font-semibold text-brand-green">
        {translate('text-large-orders', { ns: 'common' })}
      </p>
    )
  )
}

export default ProductLargeOrders
